var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.19979 4.79961C9.19979 5.34818 9.06176 5.86451 8.81853 6.31576H8.82393L8.76271 6.41504C8.73837 6.45657 8.71312 6.49751 8.68699 6.53782L6.57819 9.95766C6.2579 10.4771 5.49741 10.4611 5.19924 9.92866L3.17592 6.31576H3.18107C2.93784 5.86451 2.7998 5.34818 2.7998 4.79961C2.7998 3.0323 4.23249 1.59961 5.9998 1.59961C7.76711 1.59961 9.19979 3.0323 9.19979 4.79961ZM5.9999 6.39974C6.88356 6.39974 7.5999 5.6834 7.5999 4.79974C7.5999 3.91609 6.88356 3.19974 5.9999 3.19974C5.11625 3.19974 4.3999 3.91609 4.3999 4.79974C4.3999 5.6834 5.11625 6.39974 5.9999 6.39974Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.2a69102cee742b55a8d2b14cd9b6c9ec.svg";
export { ForwardRef as ReactComponent };